module.exports = __webpack_public_path__ + "img/footer_logotype.8fd94ad5.svg";